import React, { useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { addJobOpening } from "../../utils/helper";
import { alertSuccess, alertError } from "../../utils/alerts";
import { states } from "../../utils/dataFile";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const INIT_STATE = {
    jobTitle: "",
    jobType: "",
    industry: "",
    location: "",
    min_qualification: "",
    experience_length: "",
    job_level:"",
    jobSummary: "",
    jobDescription: "",
    currency: "",
    monthly_salary: "",
    negotiable: "",
    days_online: "",
    available_openings: "",
};

export default function AddJob() {
    const [state, setState] = useState(INIT_STATE);
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    const handleChange = (e) => {
        e.persist();
        setState((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = {
            ...state,
        };

        if(data.jobType && data.jobSummary && data.jobDescription && data.jobTitle){
            setLoading(true);
            addJobOpening(data)
            .then((res) => {
                if(res.data.success){
                    alertSuccess(res.data.message)
                    setTimeout(() => {
                        history.push('/recruitment/jobs');
                    }, 3500);
                } else {
                    alertError(res.data.message)
                }
                setLoading(false);
            })
            .catch((err) => {
                alertError(err.response?.data?.error);
                setLoading(false);
            });
        }
    };
    
    return (
        <>
            <h1 className="dash-title"><Link to="/recruitment/jobs" style={{color: '#454545'}}><i className="fa fa-arrow-left"></i> Go Back</Link></h1>

            <div className="row dash-row">
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Create Job Opening</div>
                        </div>
                        <div className="card-body">
                            <form method="post" encType="multipart/form-data" onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-md-12 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Job Title: <span>*</span></label>
                                        <input name="jobTitle"  type="text" placeholder="Job Title" className="form-control" required 
                                        onChange={handleChange} defaultValue={state.jobTitle || ""}/>
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Job Type: <span>*</span></label>
                                        <select className="form-control form-select" name="jobType" id="jobType" required  
                                        onChange={handleChange} defaultValue={state.jobType || ""}>
                                            <option value=''>Select...</option>
                                            <option value="full-time">Full-Time</option>
                                            <option value="part-time">Part-Time</option>
                                            <option value="internship">Internship and Graduate</option>
                                            <option value="contract">Contract</option>
                                        </select>
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Industry: <span>*</span></label>
                                        <select className="form-control form-select" name="industry" id="industry" required  
                                        onChange={handleChange} defaultValue={state.industry || ""}>
                                            <option value=''>Select...</option>
                                            <option value="accounting">Accounting</option>
                                            <option value="administrative-and-office">Administrative and Office</option>
                                            <option value="agriculture-fishing-forestry">Agriculture, Fishing & Forestry</option>
                                            <option value="automotive-aviation">Automotive & Aviation</option>
                                            <option value="advertising-media-communications">Advertising, Media & Communications</option>
                                            <option value="banking-finance-insurance">Banking, Finance & Insurance</option>
                                            <option value="construction">Construction</option>
                                            <option value="consulting">Consulting</option>
                                            <option value="creative-and-design">Creative and Design</option>
                                            <option value="customer-service-and-support">Customer Service and Support</option>
                                            <option value="education">Education</option>
                                            <option value="enforcement-security">Enforcement & Security</option>
                                            <option value="engineering-and-construction">Engineering and Construction</option>
                                            <option value="health-and-safety">Health and Safety</option>
                                            <option value="human-resources">Human Resources</option>
                                            <option value="energy-utilities">Energy & Utilities</option>
                                            <option value="entertainment-events-sport">Entertainment, Events & Sport</option>
                                            <option value="healthcare">Healthcare</option>
                                            <option value="hospitality-hotel">Hospitality & Hotel</option>
                                            <option value="it-telecoms">IT & Telecoms</option>
                                            <option value="law-compliance">Law & Compliance</option>
                                            <option value="manufacturing-warehousing">Manufacturing & Warehousing</option>
                                            <option value="mining-energy-metals">Mining, Energy & Metals</option>
                                            <option value="ngo-npo-charity">NGO, NPO & Charity</option>
                                            <option value="real-estate">Real Estate</option>
                                            <option value="recruitment">Recruitment</option>
                                            <option value="retail-fashion-fmcg">Retail, Fashion & FMCG</option>
                                            <option value="shipping-logistics">Shipping & Logistics</option>
                                            <option value="tourism-travel">Tourism & Travel</option>
                                            <option value="unspecified">Unspecified</option>
                                        </select>
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Location: <span>*</span></label>
                                        <select className="form-control form-select" name="location" id="location" required  
                                        onChange={handleChange} defaultValue={state.location || ""}>
                                            <option value=''>Select...</option>
                                            {states && states.map((item, i) => (
                                                <option key={i} value={item.value}>{item.label && item.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Minimum Qualification: <span>*</span></label>
                                        <select className="form-control form-select" name="min_qualification" id="min_qualification" required  
                                        onChange={handleChange} defaultValue={state.min_qualification || ""}>
                                            <option value=''>Select...</option>
                                            <option value="ssce">School Certificate (SSCE)</option>
                                            <option value="diploma">National Diploma (OND/HND)</option>
                                            <option value="bachelors">Bachelors Degree</option>
                                            <option value="masters">Masters</option>
                                            <option value="phd">PhD</option>
                                        </select>
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Experience Length: <span>*</span></label>
                                        <select className="form-control form-select" name="experience_length" id="experience_length" required  
                                        onChange={handleChange} defaultValue={state.experience_length || ""}>
                                            <option value=''>Select...</option>
                                            <option value='1 year'>1 year</option>
                                            <option value='2 years'>2 years</option>
                                            <option value='3 years'>3 years</option>
                                            <option value='4 years'>4 years</option>
                                            <option value='5 years'>5 years</option>
                                            <option value='6 years'>6 years</option>
                                            <option value='7 years'>7 years</option>
                                            <option value='8 years'>8 years</option>
                                            <option value='9 years'>9 years</option>
                                            <option value='10 years'>10 years</option>
                                        </select>
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Job Level: <span>*</span></label>
                                        <select className="form-control form-select" name="job_level" id="job_level" required  
                                        onChange={handleChange} defaultValue={state.job_level || ""}>
                                            <option value=''>Select...</option>
                                            <option value="no-experience">No Experience</option>
                                            <option value="internship-graduate">Internship and Graduate</option>
                                            <option value="entry-level">Entry Level</option>
                                            <option value="mid-level">Mid Level</option>
                                            <option value="senior-level">Senior Level</option>
                                            <option value="executive-level">Executive Level</option>
                                        </select>
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Currency: <span>*</span></label>
                                        <select className="form-control form-select" name="currency" id="currency" required  
                                        onChange={handleChange} defaultValue={state.currency || ""}>
                                            <option value=''>Select...</option>
                                            <option value="USD">USD</option>
                                            <option value="NGN">NGN</option>
                                        </select>
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Monthly Salary (Gross): <span>*</span></label>
                                        <input name="monthly_salary"  type="text" placeholder="Monthly Salary (Gross)" className="form-control" required 
                                        onChange={handleChange} defaultValue={state.monthly_salary || ""}/>
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Is Salary Negotiable?: <span>*</span></label>
                                        <select className="form-control form-select" name="negotiable" id="negotiable" required  
                                        onChange={handleChange} defaultValue={state.negotiable || ""}>
                                            <option value=''>Select...</option>
                                            <option value='Yes'>Yes</option>
                                            <option value='No'>No</option>
                                        </select>
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Days Online: <span>*</span></label>
                                        <select className="form-control form-select" name="days_online" id="days_online" required  
                                        onChange={handleChange} defaultValue={state.days_online || ""}>
                                            <option value=''>Select...</option>
                                            <option value='30'>30 days</option>
                                            <option value='45'>45 days</option>
                                            <option value='90'>90 days</option>
                                        </select>
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Available Openings: <span>*</span></label>
                                        <select className="form-control form-select" name="available_openings" id="available_openings" required  
                                        onChange={handleChange} defaultValue={state.available_openings || ""}>
                                            <option value=''>Select...</option>
                                            <option value='1'>1</option>
                                            <option value='2'>2</option>
                                            <option value='3'>3</option>
                                            <option value='4'>4</option>
                                            <option value='5'>5</option>
                                            <option value='6'>6</option>
                                            <option value='7'>7</option>
                                            <option value='8'>8</option>
                                            <option value='9'>9</option>
                                            <option value='10'>10</option>
                                        </select>
                                    </div>
                                    <div className="col-md-12 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Job Summary: <span>*</span></label>
                                        <textarea name="jobSummary" cols="33" rows={3} placeholder="Job Summary" className="form-control" required 
                                        onChange={handleChange} defaultValue={state.jobSummary || ""}></textarea>
                                    </div>
                                    <div className="col-md-12 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Job Description/Requirements: <span>*</span></label>
                                        <textarea name="jobDescription" cols="33" rows={3} placeholder="Description/Requirements" className="form-control" 
                                            required onChange={handleChange} defaultValue={state.jobDescription || ""}></textarea>
                                    </div>
                                </div>
                                <div className="row form-group">
                                    <div className="col-md-12 col-sm-12">
                                        <button 
                                            type="submit" 
                                            disabled={loading}
                                            className="btn btn-primary" 
                                            onClick={() => handleSubmit}
                                        >
                                            {loading ? <i className="fa fa-spinner fa-spin"></i> : "CREATE JOB OPENING" }
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
